export enum MediaType {
  Audio = 'audio',
  Video = 'video',
}
